//main
import ContentFormatXW from "../content/webc/content-format-xw";

import WebbDividerSmall from "../content/webb/webb-divider-sm";
import WebbDividerMedium from "../content/webb/webb-divider-md";
import HeaderSectionDark from "../content/webb/head-section-dark";

import TokensViewWWModule from "../content/tokens/tokens-view-ww";

export default function TokensViewWW() {

  return (
  <>
    <ContentFormatXW 
      head='Tokens'
      link={`/home`}
      form= 'small'
      data= {
        <>
          <WebbDividerSmall/>
          <TokensViewWWModule />

        </>
      } 
    />
  </>
  )
}